import styled from 'styled-components';

export const BannerContainer = styled.div`
  width: 100%;
  height: 380px;
  background: #fef0f0;
  display: flex;
  position: relative;
  margin: 0 0 30px;

  @media (max-width: 720px) {
    height: 260px;
  }
`;

export const LeftSection = styled.div`
  background: #fef0f0;
  width: 45%;
  height: 100%;
`;
export const RightSection = styled.div`
  width: 55%;
  border-bottom: 380px solid #effafc;
  border-left: 140px solid transparent;
  border-right: 0px solid transparent;
  height: 0;

  @media (max-width: 720px) {
    border-bottom: 260px solid #effafc;
    border-left: 70px solid transparent;
  }
`;

export const AboutBaby = styled.div`
  display: flex;
  align-items: center;
  width: 60%;
  height: auto;
  column-gap: 40px;
  position: absolute;
  left: 0;
  right: 0;
  top: 20px;
  margin: auto;

  @media (max-width: 720px) {
    width: 95%;
    column-gap: 16px;
    top: 10px;
  }
`;

export const BabyImage = styled.img`
  width: 100%;
  max-width: 220px;
  height: auto;

  @media (max-width: 720px) {
    max-width: 130px;
  }
`;

export const BannerWave = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  bottom: -30px;
  left: 0;
`;

export const BabyNameTitle = styled.h2`
  font-size: clamp(20px, 4vw, 36px);
  font-weight: 600;
  color: rgb(0 0 0 / 60%);
  padding: 10px 0 30px;
  text-decoration: underline;
  text-decoration-thickness: 4px;
  text-underline-offset: 18px;
  text-decoration-color: #bfecf8;

  @media (max-width: 720px) {
    text-underline-offset: 1px;
    padding: 10px 0 16px;
  }
`;

export const BabyNameContent = styled.p`
  line-height: 24px;
  font-size: clamp(12px, 2vw, 15px);
  color: rgb(0 0 0 / 87%);

  @media (max-width: 720px) {
    line-height: 16px;
  }
`;
